import { ApiService } from './../../../services/api.service';
import { MessageType } from './../../../constants/constant';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SessionService } from '../../../services/session.service';


@Injectable()
export class PopupModalService {
    message : string = "";
    constructor(private router: Router, private sessionService: SessionService,private api: ApiService) { }

    showPopup(type, timeout, message, shouldRedirect) {
        try {
            const popupCnt = document.getElementById('popup-m-cnt');
            const popupIcon = document.getElementById('pop-m-icon');
            const popupModal = document.getElementById('popup-modal');
            const popupMessage = document.getElementById('popup-m-message');
    
            if (type === MessageType.ERROR) {
                this.backendErrorLogging(message).subscribe({
                    next: (res) => console.log(res),
                    error: (err) => console.error("Error logging to backend:", err)
                });
            }
    
            // Reset previous classes
            if(popupCnt){
                popupCnt.classList.remove('success', 'info', 'ion-alert-circled');
            }
            if(popupIcon){
                popupIcon.classList.remove('ion-android-done', 'ion-information-circled', 'ion-alert-circled');
            }
    
            // Apply styles based on type
            switch (type) {
                case 'success':
                    // popupCnt.classList.add('success');
                    // popupIcon.classList.add('ion-android-done');
                    break;
                case 'info':
                    // popupCnt.classList.add('info');
                    // popupIcon.classList.add('ion-information-circled');
                    break;
                default:
                    // popupIcon.classList.add('ion-alert-circled');
            }

            if(popupModal){
                popupModal.style.display = 'flex';
            }
            if(popupMessage){
                popupMessage.innerText = message;
            }
            if(popupCnt){
                popupCnt.classList.toggle('active');
            }
            this.message = message;
    
            setTimeout(() => {
                this.hidePopup();
                this.message = "";
                if (shouldRedirect) {
                    this.sessionService.removeAll();
                    this.router.navigate(['/welcome']);
                }
            }, timeout || 3500); // Default timeout if not provided
    
        } catch (error) {
            console.error("Unexpected error in showPopup:", error);
        }
    }
    
    hidePopup() {
        try {
            const popupCnt = document.getElementById('popup-m-cnt');
            const popupIcon = document.getElementById('pop-m-icon');
            const popupMessage = document.getElementById('popup-m-message');
            const popupModal = document.getElementById('popup-modal');
    
            if (popupIcon) {
                popupIcon.classList.remove('ion-alert-circled', 'ion-android-done', 'ion-information-circled');
            }
    
            if (popupCnt) {
                popupCnt.classList.toggle('active');
                popupCnt.classList.remove('success', 'info', 'ion-alert-circled');
            }
    
            if (popupMessage) {
                popupMessage.innerText = '';
            }
    
            if (popupModal) {
                popupModal.style.display = 'none';
            }
    
        } catch (error) {
            console.error("Unexpected error in hidePopup:", error);
        }
    }


    backendErrorLogging(msg) {
        const body = {
            marketplace_user_id: this.sessionService.get('config').marketplace_user_id,
            vendor_id: this.sessionService.get('appData') ? this.sessionService.get('appData').vendor_details.vendor_id : undefined,
            error_message: msg,
            app_type: 4,
            customer_side_error: 1,
            screen:window.location.href,
            metadata: JSON.stringify({
                origin_url: window.location.href,
                app_type:'WebApp'
            })
        };
        const obj = {
            'url': 'error/log',
            'body': body,
        };

        return this.api.post(obj);
    }
}
